import React, { useState, useEffect } from "react";
import "../../../assets/scss/components/externalTotp.scss";
import EdButton from "../../../components/generic/edButton";
import InputField from "../../../components/generic/inputField";
import EtotpIcon from "../../../assets/images/TotpIcon.png"
import ConfirmPopup from "../../../components/generic/confirmPopup";
import GreenTick from "../../../assets/images/greenTick.png"
import { getTolocalStorage } from "../../Constants/commenFeatures";
import loginService from "../../../services/login/loginService";
import { accRedircet } from "../../../services/genralServise";
import { config } from "../../../config/domain";
import LoginService from "../../../services/login/loginService";
import { generateSecretkey, validateSecretkey } from "../../../services/ExternalTOTP/etotpApiService";
import LoginErrMsg from "../../../components/login/generic/loginErrMsg";

const EnableFlow = () => {
    const [validateSKError, setValidateSKError] = useState<string>("")
    const [imgUrl, setImgUrl] = useState("")
    const [userId, setUserId] = useState("");
    const [accTyp, setAccTyp] = useState("");
    const [apiError, setApiError] = useState("");
    const [showSecKey, setShowSecKey] = useState(false);
    const [needHelp, setNeedHelp] = useState(false);
    const [totp, setTotp] = useState("");
    const [secretKey, setSecretKey] = useState('');
    const [oldPwd, setOldPwd] = useState("");
    const [showConfirmpopup, setShowConfirmpopup] = useState(false);
    const [showDonepopup, setShowDonepopup] = useState(false);
    const [showPassword, setShowPassword] = React.useState(false);
    const [QRcodePage, setQRcodePAge]= useState(false);
    const [totpError, setTotpError] = useState("");
    const [oldPwdError, setOldPwdError] = useState("");

    useEffect(() => {
        let userId = LoginService.getAccData("userID");
        let acntTyp = LoginService.getAccData("accTyp");
        if(acntTyp === "COMEQ")
            acntTyp = localStorage.getItem("accntTyp");
        setUserId(userId);
        setAccTyp(acntTyp);
    },[]);

    function Secretkeygeneration(){
        let payload = {
            userId: userId,
            acTyp: accTyp,
        };
        generateSecretkey(generateSecretkeyRes, payload)
    }   

    const generateSecretkeyRes = (res:any) => {
        if (res.data) {
            setSecretKey(res.data.secretKey);
            setImgUrl(res.data.secretKeyQR);
            // setOtpScreen(false);
            setQRcodePAge(true);
        } else if (res.error) {
            setApiError(res.error.errMsg);
            setTimeout(() => {
                setApiError("");
            }, 5000);
        }
    }
    function backTOInitial(){
        // setOtpScreen(false);
        setQRcodePAge(false);
    }
    function validateTotp(){
        let payload = {
            userId: userId,
            acTyp: accTyp,
            pwd: oldPwd,
            secretKey: secretKey,
            etotp: totp
        };
        validateSecretkey(validateSecretkeyRes, payload);    
    }
    const validateSecretkeyRes = (res:any) => {
        if (res?.data && res.data ) {
            setShowDonepopup(true);  
            setShowConfirmpopup(false); 
        } else if (res.error){
            setShowConfirmpopup(false);
            setValidateSKError(res.error.errMsg);
        }
    }
    function dontProceed(){
        // setOtpScreen(false);
        setShowConfirmpopup(false);
        setShowDonepopup(false);
        setQRcodePAge(false);
    }
    const logout = () => {
        let loginAs = getTolocalStorage("loginAs");
        if (loginAs === "vendor") {
          loginService.vendorLogout();
        } else {
          loginService.logout();
        }
        accRedircet(config.root);
    };
    function handleEnableClick() {
        // Reset errors
        setTotpError("");
        setOldPwdError("");

        let valid = true;

        if (!totp || totp.length !== 6) {
            setTotpError("Enter a valid 6-digit TOTP.");
            valid = false;
        }

        if (!oldPwd) {
            setOldPwdError("Current password is required.");
            valid = false;
        }

        if (valid) {
            setShowConfirmpopup(true);
        }
    }


    return (
        <>
        <div className="totp-container">
            { !QRcodePage && <div className="totp-content-container">
                <h2 className="heading pd-b43">External 2FA TOTP</h2>
                <div>
                    <div className="row">
                        <div className="column-left">
                            <img src={EtotpIcon} alt="External TOTP icon"></img>
                        </div>
                        <div className="column-right">
                            <p className="totp-info pd-b30">Use external TOTP apps like Google® Authenticator, Microsoft® Authenticator, or Authy on your phone or desktop  to generate random 6 digit TOTPs for every login. Learn more. Even if external TOTP is enabled, login with Traditional OTP flow will still be available.</p>
                            <div className="display-center2">
                                <EdButton
                                    value="Enable external TOTP"
                                    btnTyp="primary"
                                    className="submit_btn btn-w240"
                                    onClick= {Secretkeygeneration}
                                />
                                {apiError && (
                                    <LoginErrMsg className="mg-t30 btn-w380">
                                        {apiError}
                                    </LoginErrMsg>
                                )} 
                            </div>                                               
                        </div>                
                    </div>       
                </div>     
            </div>}
            {QRcodePage &&(
                <div className="totp-content-container">
                    <h2 className="heading pd-b30">External 2FA TOTP</h2>
                    <div className="row">
                        <div className="column-left">
                            {imgUrl ? <img className="wd-230" src={`data:image/png;base64,${imgUrl}`}/> :<img src={EtotpIcon} alt="External TOTP icon"></img>}
                            <div className="text_btn"><a onClick={()=>setShowSecKey(true)} className="font-12">Can't scan? Copy the Key.</a></div>
                            {showSecKey && <span className="secret-key-text "><a onClick={() => { navigator.clipboard.writeText(secretKey)}}>{secretKey}</a></span>}
                        </div>
                        <div className="column-right pd-t15">
                            { !needHelp && (
                                <div>
                                <h3 className="sub-heading">Scan the QR code on your authenticator app</h3>
                                <p className="totp-info pd-b30">Once scanned, the app should give you a 6 digit TOTP. Enter it here.
                                    <a className="blue-txt" onClick={() => {setNeedHelp(!needHelp)}}> Need Help?</a>
                                </p>
                                <label htmlFor="totp" className="totp-info mg-b5 ib">6 Digit TOTP</label>
                                <div>
                                    <InputField
                                    id="totp"
                                    defaultValue={totp ? totp : ""}
                                    onChange={(val) => {
                                        setTotp(val);
                                        if (val && val.length === 6) setTotpError("");
                                    }}
                                    onBlur={() => {}}
                                    className="login_inp mg-b40 focus etotp-btn-w400 btn-wXS"
                                    placeholder="Enter"
                                    integer={true}
                                    maxLength={6}
                                    autoComplete="off"
                                    errorText={totpError}
                                    />
                                </div>

                                <label  htmlFor="oldPwd" className="totp-info mg-b5 ib">Current Password</label>
                                <div>
                                    <InputField
                                    autoComplete="off"
                                    defaultValue={oldPwd ? oldPwd : ""}
                                    id="oldPwd"
                                    type={showPassword ? "text" : "password"}
                                    onChange={(val) => {
                                        setOldPwd(val);
                                        if (val) setOldPwdError("");
                                    }}
                                    onBlur={() => {}}
                                    className="login_inp mg-b15 etotp-btn-w400 btn-wXS"
                                    placeholder="Enter password"
                                    autoFocus={false}
                                    suffix={
                                        <button
                                        type="button"
                                        onClick={() => setShowPassword(!showPassword)}
                                        aria-label={showPassword ? "Hide password" : "Show password"}
                                        aria-pressed={showPassword}
                                        style={{
                                            background: "none",
                                            border: "none",
                                            cursor: "pointer",
                                            padding: "0 4px",
                                            display: "flex",
                                            alignItems: "center",
                                        }}
                                        >
                                        <i
                                            className={`edel-icon-eye${showPassword ? "-cross" : ""} icon`}
                                            aria-hidden="true"
                                        />
                                        </button>
                                    }
                                    errorText={oldPwdError}
                                    />
                                    <p className="etotp-btn-w400 greyText font-12 btn-wXS mg-b40">Important: Once external TOTP is setup. you have to use the same mobile authenticator app to generate a new 6-digit TOTP every time you login</p>
                                </div>

                                <div className="display-center">
                                    <EdButton
                                        value="Cancel"
                                        btnTyp="secondary"
                                        className="submit_btn btn-w195 etotp-btn"
                                        onClick= {backTOInitial}
                                    />
                                    <EdButton
                                        value="Enable"
                                        btnTyp="primary"
                                        className="submit_btn btn-w195 etotp-btn"
                                        onClick={handleEnableClick}
                                    />
                                </div>
                                </div>
                            )}
                            { needHelp && (
                                <div className="modal_deleteApp">
                                <div className="modal_delete_content  delete_modal"> 
                                  <div className="deleteApiApp">
                                  {/* <div className="text-right"><a className="blue-txt" onClick={() => {setNeedHelp(!needHelp)}}><i className="edel-icon-arrow-left"></i>Back</a></div> */}
                                    <div className="text-right pd-b15">
                                        <button
                                            type="button"
                                            aria-label="Close Redirect URL assist modal"
                                            onClick={() => setNeedHelp(false)}
                                            style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                                        >
                                            <i className="edel-icon-close" aria-hidden="true" />
                                        </button>
                                    </div>
                                    
                                    <div className="apiConnect delete_apiConnect">                                 
                                        <h3 className="sub-heading font-16">Apps to be downloaded on PCs or phones to generate the external TOTP:</h3>
                                        <ul className="totp-info font-16">
                                            <li><p>Google® Authenticator available on Google Play (<a className="blue-txt" href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" target="_blank">WEB</a>) and App store (<a className="blue-txt" href="https://apps.apple.com/us/app/google-authenticator/id388497605" target="_blank">WEB</a>).</p></li>
                                            <li><p>Microsoft® Authenticator available on Google Play (<a className="blue-txt" href="https://play.google.com/store/apps/details?id=com.azure.authenticator" target="_blank">WEB</a>) and App store (<a className="blue-txt" href="https://apps.apple.com/us/app/microsoft-authenticator/id983156458" target="_blank">WEB</a>).</p></li>
                                            <li><p>Authy available on Google Play (<a className="blue-txt" href="https://play.google.com/store/apps/details?id=com.authy.authy" target="_blank">WEB</a>) and App store (<a className="blue-txt" href="https://apps.apple.com/us/app/twilio-authy/id494168017" target="_blank">WEB</a>).</p></li>
                                            <li><p>LastPass Authenticator on Google Play (<a className="blue-txt" href="https://play.google.com/store/apps/details?id=com.lastpass.authenticator" target="_blank">WEB</a>) and App store (<a className="blue-txt" href="https://apps.apple.com/us/app/lastpass-authenticator/id1079110004" target="_blank">WEB</a>).</p></li>
                                            <li><p>Bitwarden (<a className="blue-txt" href="https://bitwarden.com/download/" target="_blank">WEB</a>).</p></li>
                                        </ul> 
                                    </div>
                                  </div>
                                </div>
                              </div>
                                // <div>
                                //     <div className="text-right"><a className="blue-txt" onClick={() => {setNeedHelp(!needHelp)}}><i className="edel-icon-arrow-left"></i>Back</a></div>
                                //     <br/>
                                //     <h5 className="sub-heading font-16">Apps to be downloaded on PCs or phones to generate the external TOTP:</h5>
                                //     <ul className="totp-info font-16">
                                //         <li><p>Google® Authenticator available on Google Play (<a className="blue-txt" href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator">WEB</a>) and App store (<a className="blue-txt" href="https://apps.apple.com/us/app/google-authenticator/id388497605">WEB</a>).</p></li>
                                //         <li><p>Microsoft® Authenticator available on Google Play (<a className="blue-txt" href="https://play.google.com/store/apps/details?id=com.azure.authenticator">WEB</a>) and App store (<a className="blue-txt" href="https://apps.apple.com/us/app/microsoft-authenticator/id983156458">WEB</a>).</p></li>
                                //         <li><p>Authy available on Google Play (<a className="blue-txt" href="https://play.google.com/store/apps/details?id=com.authy.authy">WEB</a>) and App store (<a className="blue-txt" href="https://apps.apple.com/us/app/twilio-authy/id494168017">WEB</a>).</p></li>
                                //         <li><p>LastPass Authenticator on Google Play (<a className="blue-txt" href="https://play.google.com/store/apps/details?id=com.lastpass.authenticator">WEB</a>) and App store (<a className="blue-txt" href="https://apps.apple.com/us/app/lastpass-authenticator/id1079110004">WEB</a>).</p></li>
                                //         <li><p>Bitwarden (<a className="blue-txt" href="https://bitwarden.com/download/">WEB</a>).</p></li>
                                //     </ul>                           
                                // </div>
                            )}
                            {validateSKError && (
                                <LoginErrMsg className="mg-t30 btn-w380">
                                    {validateSKError}
                                </LoginErrMsg>
                            )}
                            { showConfirmpopup && (
                                <ConfirmPopup
                                heading=""
                                heading2="Your active sessions on all Nuvama platforms will expire, would you like to proceed."
                                subHeading=""
                                buttonPrimary={true}
                                buttonSecondary={true}
                                buttonPrimaryValue="Yes"
                                buttonSecondaryValue="No"
                                OnclickBtnP={validateTotp}
                                OnclickBtnS={dontProceed}
                                />
                            )}
                            { showDonepopup && (
                                <ConfirmPopup
                                heading="External TOTP Enabled"
                                subHeading="External TOTP is now enabled on your account. All your active sessions on Nuvama platforms are expired. Please re-login to continue."
                                buttonPrimary={false}
                                buttonSecondary={true}
                                imageSrc={GreenTick}
                                imgAlt="Enabled Icon"
                                buttonSecondaryValue="Ok Got, it"
                                OnclickBtnS={logout}
                                />
                            )}
                        </div>                 
                    </div>       
                </div>
            )}
        </div>
        </>
    )
}
export default EnableFlow;